<div class="h-100">
  <finxone-web-frontend-intl-new-currency-country-widget
    class="h-100"
    [showCurrencyFlags]="showCurrencyFlags"
    [currencyCodes]="currenciesCodes"
    [countryList]="countryList"
    [customStyle]="contentStyle"
    [widgetConfig]="widgetConfig"
    [isSubmitTypeAsynchronous]="true"
    (formChangeEvent)="updateFormActionState($event)"
  >
  </finxone-web-frontend-intl-new-currency-country-widget>
</div>
